/* eslint-disable import/prefer-default-export */
import { defaultMarketplaceItemDetailsFormSections } from '../shopConfig/config';
import { ListingItemType } from '../types/sharetribe/listing';
import { useEnabledCustomerExperiences } from './useEnabledCustomerExperiences';
import { useTradeInConfig } from './useTradeInConfig';

export const useItemDetailsFormSections = () => {
  const tradeInConfig = useTradeInConfig();
  const { isListSellOnly, allowTradeIn } = useEnabledCustomerExperiences();

  return (itemType?: ListingItemType) => {
    const isListingItemTypeMarketplace = !!itemType && itemType === ListingItemType.Marketplace;
    const isMarketplace = isListSellOnly;
    if (isMarketplace || isListingItemTypeMarketplace) {
      // Put marketplace form sections into config if in the future it changes per brand.
      return defaultMarketplaceItemDetailsFormSections;
    }
    const isListingItemTypeTradeIn = !!itemType && itemType === ListingItemType.TradeIn;
    const isTradeIn = isListingItemTypeTradeIn || allowTradeIn;
    const tradeInItemDetailsFormSections = tradeInConfig?.tradeInItemDetailsFormSections;
    return isTradeIn ? tradeInItemDetailsFormSections : [];
  };
};
